module.exports = __webpack_public_path__ + "img/makarenko.e02663e5.png";